import { render, staticRenderFns } from "./iframe.vue?vue&type=template&id=2360c7fc&scoped=true"
import script from "./iframe.vue?vue&type=script&lang=js"
export * from "./iframe.vue?vue&type=script&lang=js"
import style0 from "./iframe.vue?vue&type=style&index=0&id=2360c7fc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2360c7fc",
  null
  
)

export default component.exports